/*
 * searches reducer
 */
import { RESET_STATE } from '../auth/constants';
import { SET_SEARCH, RESET_SEARCH } from './constants';

type State = {};

type Action = {
    +type: string,
    +payload?: Object
};

const initialState = {};

export default function(state: State = initialState, action?: Action) {
    if (!action) return state;
    switch (action.type) {
        case SET_SEARCH:
            if (action.payload) {
                return {
                    ...state,
                    [action.payload.namespace]: action.payload.search
                };
            }
            break;
        case RESET_SEARCH:
            return initialState;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
